<template>
  <div class="zzl-container">
    <div class="zzl-content">
      <div class="zzl-title">每日餐单管理</div>
      <div class="flex-between">
        <div class="zzl-search-list">
          <!-- <div class="zzl-search-item">
            <p>菜名</p>
            <el-input
              v-model="search.kw"
              placeholder="输入菜名回车搜索"
              clearable
              @change="searchData"
            ></el-input>
          </div>
          <div class="zzl-search-item">
            <el-button type="primary" @click="searchData">查询</el-button>
          </div> -->
        </div>
        <div class="zzl-search-list">
          <div class="zzl-search-item">
            <el-button type="primary" @click="addOrUpdate(1)">添加</el-button>
          </div>
        </div>
      </div>
      <div class="zzl-table-list">
        <el-table :data="tableList" max-height="640px" style="width: 100%">
          <el-table-column
            prop="name"
            label="点餐菜单"
            min-width="300"
            align="center"
            fixed="left"
          >
            <template slot-scope="scope">
              <div>
                <p
                  v-for="(item, index) of getMenu(scope.row)"
                  :key="index + 'menu'"
                >
                  {{ item }}
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="meal_date"
            label="预定时间"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="点餐分类"
            min-width="150"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.type == 'supper' ? '晚餐' : '午餐' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="是否工作餐"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.contain_work_meal == 'Y' ? '是' : '否' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="点餐时间段" min-width="320" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.start_time + " - " + scope.row.end_time }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="150"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <div class="flex-center-center">
                <span class="action-text" @click="addOrUpdate(2, scope.row)"
                  >编辑</span
                >
                <span class="action-text" @click="deleteData(scope.row)"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex-end-center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :total="pagination.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="formTitle"
      :visible.sync="formVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      append-to-body
    >
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item prop="meal_ids" label="点餐菜单">
              <el-select
                multiple
                collapse-tags
                v-model="form.meal_ids"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in mealList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="meal_date" label="预定时间">
              <el-date-picker
                v-model="form.meal_date"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="type" label="点餐分类">
              <el-radio-group v-model="form.type">
                <el-radio
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="contain_work_meal" label="是否允许工作餐">
              <el-radio-group v-model="form.contain_work_meal">
                <el-radio
                  v-for="item in containwWorkMealList"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="time" label="点餐时间段">
              <el-date-picker
                v-model="form.time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="flex-center-center">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadImage from "@/components/UploadImage.vue";

export default {
  name: "mealDay",
  components: {
    UploadImage,
  },
  data() {
    return {
      tableList: [],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        count: 0,
      },
      search: {
        kw: "",
      },

      typeList: [
        {
          value: "lunch",
          label: "午餐",
        },
        {
          value: "supper",
          label: "晚餐",
        },
      ],
      containwWorkMealList: [
        {
          value: "Y",
          label: "是",
        },
        {
          value: "N",
          label: "否",
        },
      ],
      mealList: [],
      formVisible: false,
      formTitle: "",
      form: {
        id: 0,
        type: "",
        meal_date: "",
        time: [],
        start_time: "",
        end_time: "",
        contain_work_meal: "",
        meal_ids: [],
      },
      rules: {
        type: [
          { required: true, message: "请选择点餐分类", trigger: "change" },
        ],
        meal_date: [
          { required: true, message: "请选择预定时间", trigger: "change" },
        ],
        time: [
          {
            type: "array",
            required: true,
            message: "请选择点餐时间段",
            trigger: "change",
          },
        ],
        contain_work_meal: [
          { required: true, message: "请选择是否工作餐", trigger: "change" },
        ],
        meal_ids: [
          {
            type: "array",
            required: true,
            message: "请选择点餐菜单",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    getMenu(data) {
      let arr = [];
      data.day_meal_details.forEach((item) => {
        arr.push(item.name);
      });
      return arr;
    },

    addOrUpdate(type, data) {
      this.formVisible = true;
      console.log(data);
      if (type == 1) {
        this.formTitle = "添加";
      } else {
        this.formTitle = "修改";
        let meal_ids = [];
        data.day_meal_details.forEach((item) => {
          meal_ids.push(item.id);
        });

        let obj = {
          time: [data.start_time, data.end_time],
          meal_ids,
          ...JSON.parse(JSON.stringify(data)),
        };
        this.form = obj;
      }
    },
    deleteData(data) {
      console.log(data);
      this.$confirm("该操作将永久删除本条数据,请确认是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.zzlHttp.post(this.zzlApi.delMealDay, {
            id: data.id,
          });
          if (res.code == 0) {
            this.$message.success("删除成功");
            this.searchData();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.form.start_time = this.form.time[0];
          this.form.end_time = this.form.time[1];
          let params = {
            ...this.form,
          };
          const res = await this.zzlHttp.post(
            this.zzlApi.addOrUpdateMealDay,
            params
          );
          if (res.code == 0) {
            if (params.id == 0) {
              this.$message.success("添加成功");
            } else {
              this.$message.success("更新成功");
            }
            this.getList();
            this.closeForm();
          } else {
            this.$message.error(res.msg);
          }
        }
      });
    },
    cancel() {
      this.closeForm();
    },
    closeForm() {
      this.form = {
        id: 0,
        type: "",
        meal_date: "",
        time: [],
        start_time: "",
        end_time: "",
        contain_work_meal: "",
        meal_ids: [],
      };
      this.$refs.form.resetFields();
      this.formVisible = false;
    },
    async getMeal() {
      const res = await this.zzlHttp.post(this.zzlApi.getAllMealList);
      if (res.code === 0 && res.data) {
        let keyObj = {
          value: "id",
          label: "name",
        };
        this.mealList = this.zzlFormat.getKeyArr(res.data, keyObj);
      }
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageNum = 1;
      this.pagination.pageSize = val;
      this.getList();
    },
    searchData() {
      this.pagination.pageNum = 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      let params = {
        ...this.pagination,
        ...this.search,
      };
      const res = await this.zzlHttp.post(this.zzlApi.getmealdaylist, params);
      if (res.code === 0 && res.data) {
        this.pagination.count = res.data.count || 0;
        this.tableList = res.data.list || [];
      }
    },
  },
  mounted() {
    this.getMeal();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
</style>
